import React, { Component } from 'react';
import { ButtonToolbar, ToggleButton, ToggleButtonGroup } from 'react-bootstrap';
import '../../content/css/PageFilterControl.css';

export default class PageFilterControl extends Component {
    constructor(props) {
        super(props);

        this.state = {
            importanceValue: props.initialValue.importance ? props.initialValue.importance : [],
            typeValue: props.initialValue.type ? props.initialValue.type : "predicted"
        };

        this.handleTypeChange = this.handleTypeChange.bind(this);
        this.handleImportanceChange = this.handleImportanceChange.bind(this);
    }

    handleTypeChange(typeValue) {
        this.setState({ typeValue });
        let filter = { type: typeValue, importance: this.state.importanceValue }
        this.props.onToggle(filter);
    }

    handleImportanceChange(importanceValue) {
        this.setState({ importanceValue });
        let filter = { type: this.state.typeValue, importance: importanceValue }
        this.props.onToggle(filter);
    }

    render() {
        return (
            <ButtonToolbar className="filter-toolbar">
                {this.props.isAdmin &&
                    <ToggleButtonGroup type="radio" name="type" value={this.state.typeValue} onChange={this.handleTypeChange}>
                        <ToggleButton className={'btn-all'} value={'all'}>All</ToggleButton>
                        <ToggleButton className={'btn-highlights'} value={'predicted'}>Highlights</ToggleButton>
                    </ToggleButtonGroup>
                }
                <ToggleButtonGroup type="checkbox" name="importance" value={this.state.importanceValue} onChange={this.handleImportanceChange}>
                    <ToggleButton className={'btn-low'} value={'low'}>Low</ToggleButton>
                    <ToggleButton className={'btn-medium'} value={'medium'}>Medium</ToggleButton>
                    <ToggleButton className={'btn-high'} value={'high'}>High</ToggleButton>
                </ToggleButtonGroup>
            </ButtonToolbar>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/DocumentViewer/PageFilterControl.js